import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import ContentOwnership from 'components/shared/ContentOwnership';
import * as selectors from 'selectors/pathBuilder';
import { toggleEditingUIElementByName } from 'actions/pathBuilder';
import * as actions from 'actions/pathBuilder/ownership';
import Section, { SectionHeader } from './Section';

const mapPropsToOptions = props => ownership => {
  const menu = [
    {
      label: 'Remove Ownership',
      icon: 'delete',
      onClick: props.removeOwnership,
    },
  ];

  if (props.updateOwnershipPermissions) {
    menu.push({
      label:
        ownership.permission === actions.EDIT_ONLY
          ? 'Share access to Path activity'
          : 'Revoke access to path activity',
      icon: 'bar_chart',
      onClick: props.togglePermission,
    });
  }

  return menu;
};

const UI_STATE_KEY = 'ownerships';

const Owners = ({
  editingOwnerships,
  toggleEditing,
  ownerships,
  createOwnership,
  removeOwnership,
  permission,
  togglePermission,
  updateOwnershipPermissions,
  isCertification,
  features,
}) => (
  <Section>
    <SectionHeader className="d-f jc-sb">
      <span className="w-75p">
        <span className="mr-4">
          {isCertification
            ? t('certifications.certification_builder.sidebar.owners_title')
            : 'Path Owners'}
        </span>
        <InfoTooltip tooltip={t('ownership.share.tooltip')} />
      </span>
      {!editingOwnerships && (
        <button
          type="button"
          className="u-linkBtn fz-base fw-n"
          onClick={toggleEditing}
        >
          <Icon name="edit" className="mr-4" />
          Edit
        </button>
      )}
    </SectionHeader>
    <ContentOwnership
      editing={editingOwnerships}
      toggleEditing={toggleEditing}
      ownerships={ownerships}
      onCreateOwnership={createOwnership}
      getOwnershipOptions={mapPropsToOptions({
        updateOwnershipPermissions,
        togglePermission,
        removeOwnership,
      })}
    />
  </Section>
);

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  ownerships: pathBuilder.ownerships, // mock data
  editingOwnerships: selectors.isEditingUIElementByName(
    pathBuilder,
    UI_STATE_KEY,
  ),
  updateOwnershipPermissions:
    pathBuilder.permissions.updateOwnershipPermissions,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = {
  toggleEditing: toggleEditingUIElementByName.bind(null, UI_STATE_KEY),
  removeOwnership: actions.removeOwnership,
  createOwnership: actions.createOwnership,
  togglePermission: actions.togglePermission,
};

export default connect(mapStateToProps, mapDispatchToProps)(Owners);
